import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconTickLarge = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M18.996 6.75c.172.156.258.36.258.61 0 .234-.086.43-.258.585l-9.375 9.399a.624.624 0 0 1-.422.164.543.543 0 0 1-.398-.164l-4.805-4.805a.76.76 0 0 1-.258-.586c0-.25.086-.46.258-.633a.876.876 0 0 1 .61-.234c.234 0 .437.078.609.234L8.8 14.906c.11.11.242.164.398.164a.624.624 0 0 0 .422-.164l8.156-8.156a.833.833 0 0 1 .61-.258c.234 0 .437.086.61.258z" }),
});

export { IconTickLarge };
